var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apexcharts',{attrs:{"type":"pie","width":"380","options":_vm.chartOptions,"series":_vm.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }